const cmaOps = require('./cmaOperations');
const pl = require('./data/cma_pl.json');

let newArr = null;

function getValue(val) {
  if (val && val !== Infinity) return val;
  return 0;
}

module.exports = function (cma_pl_values, fys, arrayLength) {
  cma_pl_values.cma_pl_1 = cmaOps.sum(cma_pl_values.cma_pl_2, cma_pl_values.cma_pl_3);
  cma_pl_values.cma_pl_5 = cmaOps.difference(cma_pl_values.cma_pl_1, cma_pl_values.cma_pl_4);

  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = getValue((((cma_pl_values.cma_pl_5[i] / fys[i].months) - (cma_pl_values.cma_pl_5[(i-1)] / fys[(i-1)].months))/(cma_pl_values.cma_pl_5[i-1]/fys[i-1].months))*100);
  }
  cma_pl_values.cma_pl_6 = newArr;

  cma_pl_values.cma_pl_8 = cmaOps.sum(cma_pl_values.cma_pl_5, cma_pl_values.cma_pl_7);

  cma_pl_values.cma_pl_10 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_10', pl).map(element => cma_pl_values[element]));
  cma_pl_values.cma_pl_13 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_13', pl).map(element => cma_pl_values[element]));
  cma_pl_values.cma_pl_18 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_18', pl).map(element => cma_pl_values[element]));

  cma_pl_values.cma_pl_24 = cmaOps.sum(cma_pl_values.cma_pl_10, cma_pl_values.cma_pl_13, cma_pl_values.cma_pl_16, cma_pl_values.cma_pl_17, cma_pl_values.cma_pl_18, cma_pl_values.cma_pl_22, cma_pl_values.cma_pl_23);

  cma_pl_values.cma_pl_26 = cmaOps.sum(cma_pl_values.cma_pl_24, cma_pl_values.cma_pl_25);

  cma_pl_values.cma_pl_28 = cmaOps.difference(cma_pl_values.cma_pl_26, cma_pl_values.cma_pl_27);

  cma_pl_values.cma_pl_30 = cmaOps.sum(cma_pl_values.cma_pl_28, cma_pl_values.cma_pl_29);

  cma_pl_values.cma_pl_90 = cmaOps.difference(cma_pl_values.cma_pl_30, cma_pl_values.cma_pl_31);

  cma_pl_values.cma_pl_32 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_32', pl).map(element => cma_pl_values[element]));

  cma_pl_values.cma_pl_44 = cmaOps.sum(cma_pl_values.cma_pl_90, cma_pl_values.cma_pl_32);

  cma_pl_values.cma_pl_45 = cmaOps.difference(cma_pl_values.cma_pl_8, cma_pl_values.cma_pl_44);

  cma_pl_values.cma_pl_46 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_46', pl).map(element => cma_pl_values[element]));

  cma_pl_values.cma_pl_50 = cmaOps.difference(cma_pl_values.cma_pl_45, cma_pl_values.cma_pl_46);

  cma_pl_values.cma_pl_52 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_52', pl).map(element => cma_pl_values[element]));
  cma_pl_values.cma_pl_59 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_59', pl).map(element => cma_pl_values[element]));
  cma_pl_values.cma_pl_51 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_51', pl).map(element => cma_pl_values[element]));

  cma_pl_values.cma_pl_64 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_64', pl).map(element => cma_pl_values[element]));
  cma_pl_values.cma_pl_72 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_72', pl).map(element => cma_pl_values[element]));
  cma_pl_values.cma_pl_63 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_63', pl).map(element => cma_pl_values[element]));

  cma_pl_values.cma_pl_79 = cmaOps.difference(cma_pl_values.cma_pl_51, cma_pl_values.cma_pl_63);

  cma_pl_values.cma_pl_80 = cmaOps.sum(cma_pl_values.cma_pl_50, cma_pl_values.cma_pl_79);

  cma_pl_values.cma_pl_81 = cmaOps.sum(...cmaOps.childrenIds('cma_pl_81', pl).map(element => cma_pl_values[element]));

  cma_pl_values.cma_pl_85 = cmaOps.difference(cma_pl_values.cma_pl_80, cma_pl_values.cma_pl_81);

  cma_pl_values.cma_pl_87 = cmaOps.percentage(cma_pl_values.cma_pl_86, cma_pl_values.cma_pl_85);
  cma_pl_values.cma_pl_88 = cmaOps.difference(cma_pl_values.cma_pl_85, cma_pl_values.cma_pl_86);

  cma_pl_values.cma_pl_89 = cmaOps.percentage(cma_pl_values.cma_pl_85, cma_pl_values.cma_pl_88);

  return cma_pl_values;
};



// WEBPACK FOOTER //
// ./src/cma/calculations_PL.js